import { defineStore } from 'pinia';
import { combineKillswitches, getClientSideOnlyKillswitches } from '#shared/features/killswitches';
import { UPDATE_KILLSWITCHES, LOAD_KILLSWITCHES } from '#shared/features/killswitches/types/actions';
import { useKillSwitchesFetch } from '~/composables/dumb/useNavigationFetch';
import { getKillswitchConfig } from '~/utils/getKillswitchConfig';

let loadingPromise;

// for testing purposes only
export function resetLoadingPromise() {
  loadingPromise = null;
}

export const useNavKillswitch = defineStore('navKillswitch', {
  state: () => ({
    killswitches: {},
    isFlags: false,
    isProperties: false,
  }),
  actions: {
    [UPDATE_KILLSWITCHES](killswitches) {
      this.killswitches = { ...this.killswitches, ...killswitches };
    },
    setFlagsReady() {
      this.isFlags = true;
    },
    setPropertiesReady() {
      this.isProperties = true;
    },
    [LOAD_KILLSWITCHES]({ killswitches, localKillswitches }) {
      const pageData = usePageData();
      const result = combineKillswitches({
        killswitches,
        localKillswitches,
        killswitchesOverride: pageData.killswitches?.override,
      });
      this[UPDATE_KILLSWITCHES](result);
    },
    applyKillswitches(killswitches) {
      this[UPDATE_KILLSWITCHES](killswitches);
      this.setFlagsReady();
      this.setPropertiesReady();
    },
    async fetch() {
      if (loadingPromise) {
        return loadingPromise;
      }

      const fetcher = async () => {
        const envProps = useEnvProps();
        const { hostlink: clientBaseUrl, headerFooterXapiHost: serverBaseUrl, isNavSSR } = envProps;

        try {
          const result = await useKillSwitchesFetch({
            clientBaseUrl,
            serverBaseUrl,
          });
          const isFetchSucceed = result && typeof result === 'object';

          if (isFetchSucceed) {
            const killswitches = isNavSSR ? getClientSideOnlyKillswitches(result) : result;
            await this[LOAD_KILLSWITCHES](getKillswitchConfig({ meta: { properties: killswitches } }));
          }
        } catch (error) {
          console.error('Failed to fetch killswitches:', error);
          loadingPromise = null;
        } finally {
          this.setFlagsReady();
          this.setPropertiesReady();
        }
      };

      loadingPromise = fetcher();

      return loadingPromise;
    },
  },
});
